import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import Deblais from "../components/Deblais";
class Decharges extends Component {
    render() {
        return (
            <div>
                <NavBar />

                <div
                    className="breadcrumb-area breadcrumb-bg"
                    style={{
                        backgroundImage: `url(assets/img/backgrounds/20250305_092607.jpg)`
                    }}
                >
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="page-banner text-center">
                                    <h1>Mise en décharge de matériaux inertes</h1>
                                    <ul className="page-breadcrumb">
                                        <li><a href="#deblais">Déblais</a></li>
                                        <li><a href="#reception">Réception des inertes</a></li>
                                        <li><a href="#seconde">Matériaux inertes destinés à une seconde vie les chantiers du BTP</a></li>
                                        <li><a href="#interdit">Déchets interdits</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*====================  End of breadcrumb area  ====================*/}

                <div className="service-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-12 order-1 order-lg-2" id="deblais">
                                <Deblais></Deblais>
                            </div>
                        </div>
                        <div className="section-title-area text-center" id="reception">
                            <h2 className="section-title section-space--bottom--20">Réception des inertes</h2>
                        </div>
                        <div className="blog-details col-12">
                            <div className="blog-inner">
                                <div className="content">
                                    <div className="desc section-space--bottom--30">
                                        <p>Nous réceptionnons vos déblais inertes de tous vos chantiers s’ils sont éligibles à la classe 3. Les déblais inertes terres et cailloux sont destinés à l’enfouissement dans un centre de classe 3.
                                            Notre équipe vérifiera la conformité des déblais inertes terre cailloux à l’arrivée du camion, et vous guidera de la pesée jusqu’au déchargement.
                                        </p>
                                        <p>
                                            Possibilité de vider les inertes classe 3 chez SEM (Loon Plage et Grande Synthe).
                                        </p>
                                        <blockquote className="blockquote section-space--bottom--30 section-space--top--30" id="DAP">
                                            <p>
                                                Vous devez remplir le Document d’Acceptation Préalable (DAP).
                                                Ce document est disponible en téléchargement ci-dessous, sur nos sites de recyclage,
                                                ou sur simple demande par e-mail.
                                                Une fois complété, merci de nous le retourner soit directement à nos bascules, soit par e-mail.
                                            </p>
                                            <p>
                                                <a href="/assets/pdf/DAP_Client.pdf" download>
                                                    <span style={{ fontSize: 25, color: 'Tomato', marginRight: 10 }}> <i className="fa fa-file-pdf-o" />
                                                    </span>DAP pour SEM  (PDF)</a>
                                            </p>
                                            <p>
  <a href="/assets/word/DAP_Client.docx" download>
    <span style={{ fontSize: 25, color: '#2B579A', marginRight: 10 }}>
      <i className="fa fa-file-word-o" />
    </span>
    DAP pour SEM (Word)
  </a>
</p>
                                            {/* <p>
                                                <a href="/assets/pdf/dap_siderval.pdf" download>
                                                    <span style={{ fontSize: 25, color: 'Tomato', marginRight: 10 }}> <i className="fa fa-download" />
                                                    </span>DAP pour SA</a>
                                            </p> */}
                                        </blockquote>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="section-title-area text-center" id="seconde">
                            <h2 className="section-title section-space--bottom--20">Matériaux inertes destinés à une seconde vie les chantiers du BTP</h2>
                        </div>
                        <div className="blog-details col-12">
                            <div className="blog-inner">
                                <div className="content">
                                    <div className="desc section-space--bottom--30">
                                        <p>Les déblais inertes enrobés sous forme de croûtes ou de fraisats, voiries, bétons ferraillés ou non sont destinés à être transformés pour retrouver une seconde vie sous forme de matériaux recyclés.</p>
                                        <p><b>Attention, pensez à bien trier les matériaux par type sinon ils seront déclassés en déblais inertes terre et cailloux et seront facturés en tant que tels.</b></p>
                                        <p>Notre équipe vérifiera la conformité des matériaux à recycler (HAP pour enrobés par Pak-Marker Spray) à l’arrivée du camion, et vous guidera de la pesée jusqu’au déchargement.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="section-title-area text-center" id="interdit">
                            <h2 className="section-title section-space--bottom--20">Déchets interdits sur le site</h2>
                        </div>
                        <div className="blog-details col-12 section-space--bottom--20">
                            <div className="blog-inner">
                                <div className="content">
                                    <div className="desc section-space--bottom--10">
                                        <p className="list">-	Déchets non inertes</p>
                                        <p className="list">-	Déchets non pelletables ou liquides</p>
                                        <p className="list">-	Déchets avec plus de 1% de déchets en masse (déchets flottants, gypse, etc)</p>
                                        <p className="list">-	Déchets non autorisés par l’arrêté préfectoral du site</p>
                                        <p className="list">-	Matériaux bitumineux contenant de l’amiante ou du goudron</p>
                                        <p className="list">-	Déchets dont la température est supérieure à 60°C
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
                <MobileMenu />
            </div>
        );
    }
}

export default Decharges;
